/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Ex_DeadliftInputs */

const en_features_ex_deadlift = /** @type {(inputs: Features_Ex_DeadliftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deadlift`)
};

const pl_features_ex_deadlift = /** @type {(inputs: Features_Ex_DeadliftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Martwy ciąg`)
};

/**
* | output |
* | --- |
* | "Deadlift" |
*
* @param {Features_Ex_DeadliftInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_ex_deadlift = /** @type {((inputs?: Features_Ex_DeadliftInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Ex_DeadliftInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_ex_deadlift(inputs)
	return en_features_ex_deadlift(inputs)
});